import SyHtmlTooltip from "./sy-html-tooltip";

export default SyHtmlTooltip;
